/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, createUrlTreeFromSnapshot } from '@angular/router';
import { availableContextActionClusterIds } from '@app/cluster-management/ngrx/cluster-management.selectors';
import { clustersLoaded } from '@app/core/ngrx';
import { AppState } from '@app/core/types';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ContextActionClusterIdGuard {
  constructor(private store: Store<AppState>) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!route.parent) return false;
    if (!route.children.length) return createUrlTreeFromSnapshot(route, ['..']);
    return this.store.select(clustersLoaded).pipe(
      filter(Boolean),
      switchMap(() => this.store.select(availableContextActionClusterIds)),
      map((clusterIds) => {
        const { contextActionClusterId } = route.params;
        return clusterIds.has(contextActionClusterId) ? true : createUrlTreeFromSnapshot(route, ['..']);
      }),
    );
  }
}
